import React, { useState } from "react";
import PropTypes from "prop-types";
import TimeRecordFormBodyContainer from "./TimeRecordFormBodyContainer.jsx";
import TimeRecordFormList from "./TimeRecordFormList.jsx";
import { TimeRecordParentTotalContainer } from "./TimeRecordParentTotalContainer.jsx";
import { LimitedAccess } from "../ProjectTime/Timelist/LimitedAccess.js";

const TimeRecordFormWithList = ({
  timeRecords,
  projectId,
  isBillable,
  from,
  to,
  parentId,
  parentType,
  taskId,
  loggedUserId,
  onCancel,
  onDismiss,
  users,
  source,
  defaultUserId,
  defaultUserName,
}) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <div className="tw-flex tw-justify-between tw-relative">
        <TimeRecordFormBodyContainer
          projectId={projectId}
          isBillable={isBillable}
          onCancel={onCancel}
          source={source}
          recordDate={to}
          parentId={parentId}
          parentType={parentType}
          taskId={taskId > 0 ? taskId : null}
          userId={loggedUserId}
          onDismiss={onDismiss}
          users={users}
          defaultUserId={defaultUserId}
          defaultUserName={defaultUserName}
        />
        <TimeRecordParentTotalContainer
          parentType={parentType}
          parentId={parentId}
          onChangeExpand={setShow}
          from={from}
          to={to}
        />
      </div>
      {show ? (
        <>
          <TimeRecordFormList
            className="tw-hidden sm:tw-block tw-mt-8"
            timeRecords={timeRecords}
          />
          <LimitedAccess
            projectId={projectId}
            parentId={parentId}
            parentType={parentType}
            from={from}
            to={to}
            className="tw-hidden sm:tw-block tw-mt-6"
            shouldShowLimitedAccess
          />
        </>
      ) : null}
    </>
  );
};

TimeRecordFormWithList.propTypes = {
  onDismiss: PropTypes.func,
  isBillable: PropTypes.bool,
  timeRecords: PropTypes.array,
  projectId: PropTypes.number,
  from: PropTypes.string,
  to: PropTypes.string,
  parentId: PropTypes.number,
  parentType: PropTypes.string,
  taskId: PropTypes.number,
  loggedUserId: PropTypes.number,
  onCancel: PropTypes.func,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      avatarUrl: PropTypes.string,
    })
  ),
  source: PropTypes.string,
  defaultUserId: PropTypes.number,
  defaultUserName: PropTypes.string,
};

TimeRecordFormWithList.defaultProps = {
  isBillable: false,
  timeRecords: [],
  projectId: 0,
  from: "",
  to: "",
  parentId: 0,
  parentType: "Project",
  taskId: 0,
  source: "user_timesheet",
};

export default TimeRecordFormWithList;
